import React from 'react';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/components/src/Pebbles/select';
import { Dropdown } from '@superops/ui-design-system';
import {
  reactSelectErrorStyles,
  reactSelectInlineError
} from '@nile/banyan/src/Utils/style';

export function SuperSelect({ width = 200, error, ...props }) {
  return (
    <div style={{ width }}>
      <Dropdown
        components={{ IndicatorSeparator, DropdownIndicator }}
        classNamePrefix="value_selector"
        formatGroupLabel={formatGroupLabel}
        menuPlacement="auto"
        closeMenuOnScroll={(e) => {
          return (
            e.target &&
            e.target.classList &&
            !(e.target.classList.value.indexOf('menu-list') > -1)
          );
        }}
        {...props}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({ ...base, zIndex: 9999 }),
          ...(error && reactSelectErrorStyles),
          ...props.styles
        }}
      />
      {error && reactSelectInlineError(error)}
    </div>
  );
}
